import React from 'react'

import SEO from '../../components/seo'

import Layout from '../../components/layout'

import HeaderImg from '../../components/HeaderImg/HeaderImg'
import ProjectOverview from '../../components/ProjectOverview/ProjectOverview'
import Testimonial from '../../components/Testimonial/Testimonial'
import TextBlock from '../../components/TextBlock/TextBlock'
import Slider from '../../components/Slider/Slider'
import Goals from '../../components/Goals/Goals'
import Outcomes from '../../components/Outcomes/Outcomes'
import BottomNav from '../../components/BottomNav/BottomNav'
import { JavascriptIcon } from '../../components/icons/JavascriptIcon'
import { ShopifyIcon } from '../../components/icons/ShopifyIcon'
import { SketchIcon } from '../../components/icons/SketchIcon'
import { HtmlIcon } from '../../components/icons/HtmlIcon'
import { CssIcon } from '../../components/icons/CssIcon'

const UnitruckPage = () => {
  const services = [
    {
      id: 1,
      text: 'Custom E-commerce Website and eBay store',
    },
    {
      id: 2,
      text: 'Google Apps Setup',
    },
    {
      id: 3,
      text: 'Content Marketing',
    },
  ]

  const goals = [
    {
      id: 11,
      text:
        'Facilitate Unitruck USA business expansion through a user-friendly e-commerce system',
    },
    {
      id: 22,
      text: 'Increase Unitruck brand awareness',
    },
    {
      id: 33,
      text:
        "Get visitors to sing up for a newsletter before the website's launch",
    },
  ]

  const outcomes = [
    {
      id: 111,
      title: 'Custom design',
      subtitle: 'based on the target audience',
    },
    {
      id: 222,
      title: 'Automated e-commerce system',
      subtitle: 'integrated with the fulfillment center in the USA.',
    },
    {
      id: 333,
      title: 'Custom eBay store',
      subtitle: 'linked to the Shopify platform and fulfillment center',
    },
    {
      id: 444,
      title: '12% conversion rate',
      subtitle: 'one the pre-release countdown page',
    },
  ]

  const techs = [
    {
      id: 1111,
      icon: JavascriptIcon(),
    },
    {
      id: 2222,
      icon: ShopifyIcon(),
    },
    {
      id: 3333,
      icon: SketchIcon(),
    },
    {
      id: 4444,
      icon: HtmlIcon(),
    },
    {
      id: 5555,
      icon: CssIcon(),
    },
  ]

  const slides = [
    {
      id: 1,
      img:
        'https://cdn.emersoft.co/emersoft-website/unitruck/unitruck-slider-image.jpg',
      alt: 'Unitruck with Emersoft',
    },
    {
      id: 2,
      img:
        'https://cdn.emersoft.co/emersoft-website/unitruck/unitruck-slider-image2.jpg',
      alt: 'Unitruck website on desktop',
    },
  ]

  return (
    <Layout>
      <SEO
        title="Unitruck"
        keywords={[
          `Emersoft`,
          `application`,
          `react`,
          `London`,
          `digital agency`,
        ]}
      />

      <HeaderImg
        header="header-img--unitruck"
        wrapper="header-img__img-wrapper--unitruck"
        icon={
          <svg width="208" height="34" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M30.848 4.86L26.49 23.776c-1.02 4.404-1.854 5.98-3.986 7.417-2.318 1.576-5.47 2.318-10.524 2.318C4.285 33.51.67 31.424.67 27.113c0-.835.278-2.55.603-3.94l3.94-17.2c.14-.788.185-1.02.185-1.298 0-.788-.463-1.251-1.437-1.437l.278-1.159h8.994c1.576 0 2.272.464 2.272 1.437 0 .232-.047.742-.14 1.066l-4.218 18.405c-.278 1.298-.325 1.576-.325 1.993 0 1.252.788 1.854 2.318 1.854 2.133 0 3.014-.834 3.616-3.384l3.987-17.477c.185-.788.232-1.02.232-1.298 0-.788-.51-1.251-1.484-1.437l.278-1.159h8.994c1.576 0 2.271.464 2.271 1.437 0 .325-.046.788-.185 1.345zm-2 25.637l5.61-24.524c.185-.788.231-1.02.231-1.298 0-.788-.463-1.251-1.483-1.437l.278-1.159h9.132c1.762 0 2.04.14 2.411 1.205l4.59 12.424 2.225-9.735c.185-.788.231-1.02.231-1.298 0-.788-.463-1.251-1.483-1.437l.278-1.159h7.417c1.577 0 2.272.464 2.272 1.437 0 .278-.046.696-.14 1.066L53.928 33h-5.933c-1.947 0-2.133-.14-2.782-1.9l-5.099-13.723-2.689 11.729c-.185.788-.231 1.02-.231 1.298 0 .834.463 1.252 1.437 1.437L38.398 33H30.98c-1.577 0-2.318-.464-2.318-1.437 0-.278.092-.742.185-1.066zm29.802 0l5.61-24.524c.185-.788.23-1.02.23-1.298 0-.788-.463-1.251-1.483-1.437l.279-1.159h8.993c1.623 0 2.272.464 2.272 1.484 0 .278-.047.602-.14 1.02l-5.609 24.523c-.185.788-.232 1.02-.232 1.298 0 .834.464 1.252 1.484 1.437L69.776 33h-8.994c-1.576 0-2.271-.464-2.271-1.483 0-.232.046-.603.139-1.02zm17.934 0l5.1-22.252-2.921.046c-1.808-.046-2.272.232-2.782 1.53h-1.298l1.113-4.868c.602-2.642.88-2.874 3.245-2.874h16.828c1.622 0 2.225-.324 2.689-1.483h1.39L98.79 5.51c-.556 2.503-.834 2.735-2.828 2.735h-4.45l-4.775 20.86c-.185.789-.185 1.02-.185 1.299 0 .834.463 1.252 1.437 1.437L87.71 33h-8.994c-1.576 0-2.271-.464-2.271-1.483 0-.232.046-.603.139-1.02zm19.426 0l5.61-24.524c.185-.788.232-1.02.232-1.298 0-.788-.464-1.251-1.484-1.437l.278-1.159h18.914c2.457 0 3.755.325 4.683 1.066.973.835 1.53 2.411 1.53 4.219 0 3.152-1.16 6.86-2.782 9.132-1.205 1.623-2.457 2.411-4.682 2.921l1.9 4.821c.835 2.133.974 2.272 2.69 2.272h.695l-.974 4.126c-.464 1.993-.88 2.364-2.92 2.364h-4.312c-1.761 0-1.947-.185-2.596-2.225l-3.523-11.358h-.88l-2.319 10.106c-.093.371-.139.65-.139.88 0 .835.464 1.253 1.484 1.438L107.136 33h-8.993c-1.576 0-2.318-.464-2.318-1.483 0-.232.093-.603.185-1.02zM112.33 14.27c1.344 0 2.178-.37 2.827-1.159.65-.834 1.02-2.04 1.02-3.291 0-1.437-.602-1.854-2.781-1.854h-2.41l-1.438 6.304h2.782zm42.984-9.41l-4.358 18.914c-1.02 4.404-1.854 5.98-3.986 7.417-2.318 1.576-5.47 2.318-10.524 2.318-7.695 0-11.311-2.086-11.311-6.397 0-.835.278-2.55.603-3.94l3.94-17.2c.14-.788.186-1.02.186-1.298 0-.788-.464-1.251-1.438-1.437l.279-1.159h8.993c1.576 0 2.272.464 2.272 1.437 0 .232-.047.742-.14 1.066l-4.218 18.405c-.278 1.298-.325 1.576-.325 1.993 0 1.252.789 1.854 2.318 1.854 2.133 0 3.014-.834 3.616-3.384l3.987-17.477c.186-.788.232-1.02.232-1.298 0-.788-.51-1.251-1.484-1.437l.279-1.159h8.993c1.576 0 2.272.464 2.272 1.437 0 .325-.047.788-.186 1.345zm19.574 3.384h-4.45c-2.272 0-3.06.602-3.895 2.92-.51 1.391-1.344 4.45-2.04 7.65-.556 2.595-.787 3.986-.787 4.867 0 1.39.649 2.41 1.761 2.689.51.093 1.02.139 2.364.139h3.106c2.504 0 3.153-.325 3.663-1.854h1.251l-1.112 4.913c-.325 1.391-.742 2.226-1.252 2.69-1.112.926-2.132 1.066-8.762 1.066-5.516 0-7.37-.279-8.854-1.252-1.715-1.113-2.503-2.967-2.503-5.656 0-1.9.37-4.311 1.159-8.205 2.781-13.12 5.053-16.133 12.146-16.133h11.96l-.835 3.709c-.463 2.086-.927 2.457-2.92 2.457zm.799 22.252l5.609-24.524c.185-.788.232-1.02.232-1.298 0-.788-.464-1.251-1.484-1.437l.278-1.159h8.994c1.622 0 2.271.464 2.271 1.484 0 .278-.046.602-.139 1.02l-1.576 6.86 5.888-5.516c.88-.788 1.251-1.39 1.251-1.854 0-.51-.324-.742-1.112-.835l.278-1.159 10.06.046c1.066 0 1.483.279 1.483.928 0 .556-.417 1.159-1.483 2.086l-8.716 7.742 3.709 11.357c.695 2.133.834 2.272 2.596 2.272h.695l-.88 3.801c-.557 2.457-.835 2.689-3.338 2.689h-3.523c-2.226 0-2.457-.185-3.153-2.55l-3.384-11.311-2.642 2.364-1.762 7.603c-.185.788-.232 1.02-.232 1.298 0 .834.464 1.252 1.484 1.437L186.812 33h-8.994c-1.576 0-2.318-.464-2.318-1.483 0-.232.093-.603.186-1.02z"
              fill="#E51D20"
              fillRule="evenodd"
            />
          </svg>
        }
      />
      <ProjectOverview
        title="Unitruck"
        link="https://unitruck.com/"
        category='E-commerce'
        services={services}
        technologies={techs}
        subtitle="Europe's biggest supplier of mirrors and lighting for commercial trucks."
        paragraph1="Unitruck is a leading, UK-based manufacturer and distributor
        of rear-view mirrors and lighting for commercial vehicle industry.
        With 27 years of experience they estabilished themselves as
        the biggest after-market CV wing mirror distributor in Europe."
        paragraph2="Unitruck’s brand has become synonymous with the highest
        quality rear view mirrors and vehicle lighting. As of October 2018
        they started their US West Coast expansion. Unitruck chose Nevada as
        their US base."
      />
      <Testimonial
        paragraph="Guys have done an excellent job with our new Unitruck website. It looks great, it’s super fast and our e-commerce shop is nicely integrated. Excellent communication and quick execution!"
        author="Carl Schalch"
        authorRole="Managing Director"
      />
      <TextBlock
        heading="Brief"
        paragraph1="Unitruck needed an e-commerce platform to start selling
        products in a B2C fashion on the US market. At the same time they
        wanted to highlight their position in the native UK and provide
        information about the company’s roots."
        paragraph2="The platform was supposed to be simple to navigate while
        having a refreshed, modern look providing a pleasant user experience. "
      />
      <Slider slides={slides} />
      <Goals goalsList={goals} />
      <TextBlock
        heading="Our Process"
        paragraph1="To ensure that we share the same vision we made a thorough interview with Unitruck to better understand their needs."
        paragraph2="We also carried out an US market research to see who the competitors are. Having detailed analysis of what the client needs we started the planning phase for the design as well as the development part. In the meantime to signalise the imminent changes we created a countdown page letting visitors to sign up for a newsletter."
      />
      <Outcomes outcomes={outcomes} fourItems />
      <BottomNav
        heading="See More"
        firstLink="/our-work/radium"
        firstHeading="Radium"
        secondLink="/our-work/abbacruises"
        secondHeading="Abbacruises"
      />
    </Layout>
  )
}

export default UnitruckPage
